import fetcher from '../fetcher'
import type { Video, VideoType } from './types'
import config from '../../config'
import { IResponseBody } from '../types'
import { User } from '../users/types'

export const getAllVideos = async (): Promise<Array<Video> | undefined> => {
	try {
		const res: IResponseBody<Array<Video>> = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/videos`, {
			method: 'GET'
		})
		return res.data
	} catch (error: unknown) {
		console.error(`Error fetching videos: ${error}`)
		throw error
	}
}

export const getLastVideos = async (maxItems: number): Promise<Array<Video> | undefined> => {
	try {
		const urlParams = new URLSearchParams({limit: maxItems.toString()})
		const res: IResponseBody<Array<Video>> = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/videos/last?${urlParams}`, {
			method: 'GET'
		})
		return res.data
	} catch (error: unknown) {
    console.error(`Error fetching videos: ${error}`)
		throw error
	}
}

export const getRecommendedVideos = async (maxItems: number): Promise<Array<Video> | undefined> => {
	try {
		const urlParams = new URLSearchParams({limit: maxItems.toString()})
		const res: IResponseBody<Array<Video>> = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/videos/recommended?${urlParams}`, {
			method: 'GET'
		})
		return res.data
	} catch (error: unknown) {
    console.error(`Error fetching videos: ${error}`)
		throw error
	}
}

export const getRelatedVideos = async (videoId: number, maxItems: number): Promise<Array<Video> | undefined> => {
	try {
		const urlParams = new URLSearchParams({limit: maxItems.toString()})
		const res: IResponseBody<Array<Video>> = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/videos/related/${videoId}?${urlParams}`, {
			method: 'GET'
		})
		return res.data
	} catch (error: unknown) {
    console.error(`Error fetching videos: ${error}`)
		throw error
	}
}

export const getAllVideoTypes = async (): Promise<Array<VideoType> | undefined> => {
	try {
		const res: IResponseBody<Array<VideoType>> = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/videos/types`, {
			method: 'GET'
		})
		return res.data
	} catch (error: unknown) {
    console.error(`Error fetching video types: ${error}`)
		throw error
	}
}

export const getVideoById = async (id: string): Promise<Video | undefined> => {
	const res = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/videos/${id}`, { method: 'GET' })
	return res.data
}

export const upsertVideoActivity = async (_: string[], { arg }: { arg: { videoId: string, body: unknown } }): Promise<User | undefined> => {
	const res:IResponseBody<User> = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/activity/video/${arg.videoId}`, { method: 'POST', body: JSON.stringify(arg.body) })
	return res.data
}

export const bookmarkVideo = async (_: string[], { arg }: { arg: { videoId: string, saved: boolean } }) => {
	await fetcher(`${config.VITE_ZRIVE_API_URL}/api/activity/video/${arg.videoId}/bookmark`, { method: 'POST', body: JSON.stringify({ saved: arg.saved }) })
}

export const getBookmarkedVideos = async (): Promise<Video[] | undefined> => {
	const res = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/activity/video/bookmarks`, { method: 'GET' })
	return res.data
}

export const getContinueWatching = async (limit: number): Promise<Video[] | undefined> => {
	const rest = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/videos/continue-watching?limit=${limit}`, { method: 'GET' })
	return rest.data
}

export const getHistory = async (limit?: number): Promise<Video[] | undefined> => {
	const rest = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/videos/history?limit=${limit}`, { method: 'GET' })
	return rest.data
}
